<div id="viewer">
  <pdf-viewer *ngIf="documentSource!=null && !size_too_large"
              [src]="documentSource"
              [original-size]="true"
              [fit-to-page]="true"
              [(page)]="page"
              (after-load-complete)="afterLoadComplete($event)"
  ></pdf-viewer>
  <div id="fileTooLarge" *ngIf="document!=null && size_too_large">
    <mat-icon>visibility_off</mat-icon>
    {{ 'documentToHeavy' | translate: { max_size: MAX_FILE_SIZE_TO_RENDER } }}
  </div>
</div>
<p id="scroll-hint" *ngIf="!is_document_read">{{ 'doScroll' | translate }}</p>

<div id="viewer-footer">
  <button class="btn btn-primary btn-outline btn-icon" (click)="downloadWithTemporaryUrl()" [disabled]="document==null || document.ro_unauthenticated_temporary_download_url==null">
    <mat-icon>download</mat-icon>
  </button>
  <button class="btn btn-primary" [disabled]="!is_document_read" [routerLink]="['..', 'sign']">
    {{ 'signDocument' | translate }}
  </button>
</div>
